import React from "react";
import Col from "react-bootstrap/Col";
import styled from "styled-components";
import { getImage } from "gatsby-plugin-image";
import { BgImage } from "gbimage-bridge";
import Row from "react-bootstrap/Row";

const ServiceHero = ({ image, heading, text, isDarken }) => {
	const pluginImage = getImage(image);
	const StyledBackground = styled(BgImage)`
		&::before,
		&::after {
			filter: brightness(
				${({ isDarken }) => {
					return isDarken ? "50%" : "100%";
				}}
			);
		}
	`;

	return (
		<StyledBackground
			isDarken={isDarken}
			key={isDarken ? `dark` : `light`}
			image={pluginImage}
		>
			<Row
				className="text-center text-white align-items-center px-3 px-md-1 "
				style={{ minHeight: "70vh" }}
			>
				<Col className="">
					<h2 className="pb-4 service-hero-heading">{heading}</h2>
					<p className="montserrat-light service-hero-text">{text}</p>
				</Col>
			</Row>
		</StyledBackground>
	);
};

export default ServiceHero;
